export const AdminToolsRoute = {
  path: '/accounting/admintools',
  load: () => import('./AdminTools'),
  protected: true,
};
